import { TextLink, cssColorValue, semanticColors } from '@spotify-internal/encore-web';
import styled from 'styled-components';

export const StyledTextLink = styled(TextLink)`
  && {
    text-decoration: none;
    &:focus {
      box-shadow: none;
      color: ${cssColorValue(semanticColors.textBrightAccent)};
    }
  }
`;
